export const WOOD = 'wood';
export const DISTRESS = 'distress';
export const FINISH = 'finish';
export const CUSTOM = 'custom';
